


















































































































































import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../lib/ajax'
import AbpBase from '../../../lib/abpbase'
import AppConst from '../../../lib/appconst';
import Tools from '../../../lib/tools';
import QuickTable from "../../../components/table/table.vue";
import SelectDep from "../../../components/select/selectDep.vue";
import Appconst from '../../../lib/appconst';
@Component({
	name:'',
	components: {
		QuickTable,
		SelectDep
	}
})
export default class PatentManage extends AbpBase  {
    initData:any = {
        showModal: false,
        modelType:'detail',
    	searchData: {
    		AchieveName: '',
    		Paten: '',
    		Inventor: '',
    		BelongOrgId: null
    	},
        dicData: {
            allDictionary: {},
            secondOrgs: []
        },
        formData: {
        	id: '',
        	achieveName: '',
        	patentType: null,
        	paten: '',
        	inventor: '',
        	approvalNumber: '',
        	applyCode: '',
        	patentNumber: '',
        	applyDt: '',
        	authorizationNoticeDt: '',
        	lawStatus: null,
        	hasCertificate: 1,
        	belongOrgId: null,
            secondBelongOrgId: null,
            attachs:[],
            canDelete: true,
            canDeleteAttach: true,
            canEdit: true,
            canUploadAttach: true
        },
        defaultFileList: [],
        validate: {
        	achieveName: 			[{ required: true, message: '请填写专利名称', trigger: 'blur' }],
        	patentType: 			[{ required: true, type: 'number', message: '请选择专利类型', trigger: 'change' }],
        	paten: 					[{ required: true, message: '请填写专利权人', trigger: 'blur' }],
        	inventor: 				[{ required: true, message: '请填写发明人', trigger: 'blur' }],
        	approvalNumber: 		[{ required: true, message: '请填审批文号', trigger: 'blur' }],
        	applyCode: 				[{ required: true, message: '请填申请号', trigger: 'blur' }],
        	patentNumber: 			[{ required: true, message: '请填写授权公告号/专利号', trigger: 'blur' }],
        	applyDt: 				[{ required: true, type: 'date', message: '请选择申请日', trigger: 'change' }],
        	authorizationNoticeDt: 	[{ required: true, type: 'date', message: '请选择授权公告日', trigger: 'change' }],
        	lawStatus: 				[{ required: true, type: 'number', message: '请选择法律状态', trigger: 'change' }],
        	hasCertificate: 		[{ required: true, type: 'number', message: '有无证书', trigger: 'change' }],
        	belongOrgId: 			[{ required: true, type: 'number', message: '请选择部门', trigger: 'change' }]
        },
        columns: [
        	{
                title: '序号',
                key: 'achieveCode',
                align: 'center',
                width: 118
            },
            {
                title: '专利名称',
                key: 'achieveName',
                align: 'center',
                minWidth: 240,
                render: (h:any, params:any)=>{
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text'
                                    },
                                    style: {
                                        color: '#57a3f3',
                                        cursor: 'pointer'
                                    },
                                    on: {
                                        click: () => {
                                            this.showModel('detail', params.row);
                                        }
                                    }
                                }, params.row.achieveName)
                            ])
                        }
            },
            {
                title: '专利类型',
                key: 'patentTypeDesc',
                align: 'center',
                width: 160
            },
            {
                title: '专利权人',
                key: 'paten',
                align: 'center',
                width: 88
            },
            {
                title: '发明人',
                key: 'inventor',
                align: 'center',
                width: 88
            },
            {
                title: '审批文号',
                key: 'approvalNumber',
                align: 'center',
                width: 140
            },
            {
                title: '申请号',
                key: 'applyCode',
                align: 'center',
                width: 140
            },
            {
                title: '授权公告号/专利号',
                key: 'patentNumber',
                align: 'center',
                width: 140
            },
            {
                title: '申请日',
                key: 'applyDt',
                align: 'center',
                width: 130,
                render: (h:any, params:any) => {
                	return h('Col', Tools.formatDate(params.row.applyDt, 'yyyy年MM月dd日'))
                }
            },
            {
                title: '授权公告日',
                key: 'authorizationNoticeDt',
                align: 'center',
                width: 130,
                render: (h:any, params:any) => {
                	return h('Col', Tools.formatDate(params.row.authorizationNoticeDt, 'yyyy年MM月dd日'))
                }
            },
            {
                title: '法律状态',
                key: 'lawStatusDesc',
                align: 'center',
                width: 90
            },
            {
                title: '有无证书',
                key: 'hasCertificate',
                width: 90,
                align: 'center',
                render: (h:any, params:any) => {
                	return h('Col', params.row.hasCertificate ? '有' : '无');
                }
            },
            {
                title: '部门',
                key: 'belongOrg',
                align: 'center',
                width: 180,
                render: (h:any, params:any) => {
                	let orgstr = '';
                	if(params.row.belongOrg) {
                		orgstr = params.row.belongOrg.displayName;
                	}
                	if(params.row.belongOrg && params.row.secondBelongOrg) {
                		orgstr += ' / '
                	}
                	if(params.row.secondBelongOrg) {
                		orgstr += params.row.secondBelongOrg.displayName;
                	}
                	return h('Col', orgstr);
                }
            },
            {
                title: '操作',
                key: 'action',
                align: 'center',
                width: 128,
                fixed: 'right',
                render: (h:any, params:any)=>{
                    return h('span', [
                		h('Button', {
                			props: {
                				type: 'success',
                				size: 'small'
                            },
                            style:{
                                display: params.row.canEdit?'':'none'
                            },
							on: {
								click: () => {
									for(let k in this.initData.formData) {
										if(k == 'hasCertificate'){
											this.initData.formData[k] = Number(params.row[k]);
										}else if(k == 'belongOrgId'){
											this.initData.formData[k] = params.row.belongOrg ? params.row.belongOrg.id : null;
										}else if(k == 'secondBelongOrgId'){
											this.initData.formData[k] = params.row.secondBelongOrg ? params.row.secondBelongOrg.id : null;
										}else{
											this.initData.formData[k] = params.row[k];
                                        }
                                    }
                                    if(this.initData.formData.attachs) {
                                        this.initData.defaultFileList = this.initData.formData.attachs.map( (item:any) => {
                                            return {
                                                name:item.attachName,
                                                url:item.url,
                                                id:item.id,
                                                canDownload: item.canDownload,
                                                downloadUrl: item.downloadUrl
                                            }
                                        } );
                                    } else {
                                        this.initData.defaultFileList = [];
                                    }
                                    this.initData.modelType = 'edit';
                                    this.initData.formData.attachs = [];
									this.initData.showModal = true;
								}
							}
                		}, '编辑'),
                		h('Button', {
                			props: {
                				type: 'error',
                				size: 'small'
                			},
                			style: {
                                marginLeft: '10px',
                                display: params.row.canDelete?'':'none'
                			},
							on: {
								click: () => {
									this.handleDelete(params.row.id);
								}
							}
                		}, '删除')
                	])
                }
            }
        ],
         fileUrl: Appconst.fileUrl,
    }
    //临时文件上传成功回调
    UploadSuccess(res:any, file:any, fileList:any) {
        this.initData.formData.attachs.push(res.result);
    }
    //删除文件
    async DeleteFile(res:any) {
        if(res.id){
            //已有文件
            let data:any = {
                id: res.id
            }
            await Ajax.delete('/api/services/app/Achieve/DeleteAttachAsync', {params: data});
            (this as any).$refs.table.GetData();
        }else{
            //临时文件
            await Ajax.post('/api/File/DeleteTempFile?filename='+res.response.result);
            this.initData.defaultFileList.splice(this.initData.formData.attachs.indexOf(res.response.result), 1);
        }
    }
    //字典
    async GetDic() {
        //所有字典
        await this.$store.dispatch('project/GetAllDictionary')
        this.$store.state.project.allDictionary.map((item:any) => {
            this.$set(this.initData.dicData.allDictionary, item.key, item.items.map((items:any) => {
                return {
                    label: items.displayName,
                    value: items.id
                }
            }));
        });
        //当前登录用户信息
        this.$store.dispatch('session/init');
        this.initData.dicData.userInfo = this.$store.state.session.user;
    }
    GetData() {
        (this as any).$refs.table.GetData();
   	}
    @Watch('initData.formData.belongOrgId', {deep: true})
    //二级部门
    async GetSecondBelongOrg(id:any){
        if(!id) return;
        Ajax.get('/api/services/app/Organization/GetAllChildrenOrganizationByParentIdAsync?Id='+id).then((res:any)=>{
            this.initData.dicData.secondOrgs = res.data.result.map((item:any) => {
	        	return {
	        		label: item.displayName,
	        		value: item.id
	        	}
	        });
        })
    }
    // 详情
    showModel(type: any,data: any) {
        this.initData.formData = Object.assign({},data);
        this.initData.formData.belongOrgId = data.belongOrg ? data.belongOrg.id : null;
        this.initData.formData.secondBelongOrgId = data.secondBelongOrg ? data.secondBelongOrg.id : null;
        this.initData.formData.hasCertificate = this.initData.formData.hasCertificate ? Number(this.initData.formData.hasCertificate) : null;
        this.initData.showModal = true;
        this.initData.modelType = type;
    }
    // 打开新增弹窗
    handleNewAdd() {
    	try{
    		let userInfo = this.initData.dicData.userInfo;
    		this.initData.formData.belongOrgId = userInfo.organization.id;
    	}catch(e){
    		//TODO handle the exception
        }
        this.initData.modelType = 'add';
        this.initData.defaultFileList = [];
        this.initData.formData.attachs = [];
    	this.initData.showModal = true;
    }
    // 新增记录
    async handleSubmit() {
    	(this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
          		let datas:any = this.initData.formData;
                  let params:any = {};
                  console.log(this.initData.formData)
          		for(let k in this.initData.formData) {
					if(k !== 'id') {
						if(k == 'applyDt' || k == 'authorizationNoticeDt') {
							params[k] = Tools.formatDate(datas[k], 'yyyy-MM-dd');
						}else if(k == 'hasCertificate'){
							params[k] = Boolean(datas[k]);
						}else{
							params[k] = datas[k];
						}
					}
				}
            	this.initData.formLoading = true;
            	if(datas.id) {
            		params.id = datas.id;
            		await Ajax.put('/api/services/app/Achieve/UpdatePatentAsync', params).then((res:any)=>{
		                this.$Message.success('编辑成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}else{
                    console.log(params);
                    // return;
            		await Ajax.post('/api/services/app/Achieve/CreatePatentAsync', params).then((res:any)=>{
		                this.$Message.success('提交成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}
            }
        })
    }
    handleClearForm(flog:any) {
    	if(!flog) {
    		this.initData.showModal = false;
    		this.initData.formData.id = '';
    		(this as any).$refs.form.resetFields();
    	}
    }
    // 删除
    async handleDelete(id:any) {
    	this.$Modal.confirm({
            title: '操作确认',
            content: '是否确认删除此专利记录？',
            onOk: () => {
                Ajax.delete('/api/services/app/Achieve/DeleteAwardPrizeAsync?Id='+id).then((res:any)=>{
	                this.$Message.success('删除成功!');
                	this.GetData();
	            })
            }
        });
    }
    //合同切换
    SwitchContract(name:any) {
        this.$router.push({
            name: name
        })
    }
    //初始化
    mounted() {
        this.GetDic();
    }
}
